import envVariables from "./projectEnvVariables";

// The env module is untyped .js; read it through `unknown` plus a guard.
const env: unknown = envVariables;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const readEnv = (key: string): string | undefined => {
  const value = isRecord(env) ? env[key] : undefined;
  return typeof value === "string" ? value : undefined;
};

const currentVersion = {
  AppName: readEnv("VITE_REACT_APP_NAME"),
  BuildTime: readEnv("VITE_REACT_APP_BUILD_TIME"),
  BranchName: readEnv("VITE_REACT_APP_BRANCH_NAME"),
  CommitHash: readEnv("VITE_REACT_APP_COMMIT_HASH"),
};

export function printVersion(): void {
  // eslint-disable-next-line no-console
  console.log(currentVersion);
}
